module.exports = __webpack_public_path__ + "img/p-banner-1050.870a1e99.png";